import * as React from "react";
import { useLocation } from "@tanstack/react-router";
import { announce } from "@react-aria/live-announcer";

/* ── Route change announcer for screen readers ── */

export function A11yRouteAnnouncer() {
  const location = useLocation();
  const prevPath = React.useRef(location.pathname);

  React.useEffect(() => {
    if (prevPath.current === location.pathname) return;
    prevPath.current = location.pathname;

    requestAnimationFrame(() => {
      const title = document.title || location.pathname.split("/").pop() || "Page";
      announce(`Navigated to ${title}`, "polite");
    });
  }, [location.pathname]);

  return null;
}
